import { useContext } from "react";

import { UserContext } from "@modules/user/context";

import { PolicyFormLevelsAddToList } from "@modules/cve/components";

export const PolicyFormLevelsSelect = ({ viewOnly = false, activePolicy, setActivePolicy }) => {
	let { user } = useContext(UserContext);

	return (
		<>
			<h4>Policy Assignments</h4>
			{user?.levels?.organizations?.length > 0 && (<PolicyFormLevelsAddToList viewOnly={viewOnly} activePolicy={activePolicy} setActivePolicy={setActivePolicy} levelType="organizations" levelOptions={user.levels.organizations} /> )}
			<PolicyFormLevelsAddToList viewOnly={viewOnly} activePolicy={activePolicy} setActivePolicy={setActivePolicy} levelType="companies" levelOptions={user.levels.companies} />
			<PolicyFormLevelsAddToList viewOnly={viewOnly} activePolicy={activePolicy} setActivePolicy={setActivePolicy} levelType="groups" levelOptions={user.levels.groups} />
			<PolicyFormLevelsAddToList viewOnly={viewOnly} activePolicy={activePolicy} setActivePolicy={setActivePolicy} levelType="computers" levelOptions={user.levels.computers} />
		</>
	);
};
